import './Footer.css'

function Footer() {
  return (
    <footer>
      
    <div className="rectangle-diver" />
  <div> 
 <div className='content-text-footer'>

    <section>
    <div className="sunsound-footer">
            <span className="sun">Sun</span>
            <span className="sound">Sound</span>
          </div>
    </section>

    <section className='content-colum-footer'>
    <div> 
    <div className="footer-redes-sociales">Redes sociales</div>
    </div>
    <div className="footer-twitter">Twitter</div>
    <div className="footer-instagram">Instagram</div>
    <div className="footer-facebook">Facebook</div>
    <div className="footer-tiktok">TikTok</div>
    <div className="footer-discord">Discord</div>
    </section>

    <section className='content-colum-footer'>
      <div>
    <div className="footer-acerca-de">Acerca de</div>
    </div>
    <div className="footer-solana">Solana</div>
    <div className="footer-introduccin">Introducción</div>
    </section>

    <section className='content-colum-footer'>
    <div>
    <div className="footer-ingresa">Ingresa</div>
    </div>
    <div className="footer-plataforma">Plataforma</div>
    </section>
    </div>
    </div> 
    <div className="rectangle-diver" />
    </footer>
  );
}

export default Footer;
